import { render, staticRenderFns } from "./BetModal.vue?vue&type=template&id=60d3ea7b&scoped=true"
import script from "./BetModal.vue?vue&type=script&lang=js"
export * from "./BetModal.vue?vue&type=script&lang=js"
import style0 from "./BetModal.vue?vue&type=style&index=0&id=60d3ea7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3ea7b",
  null
  
)

export default component.exports